import { jsxs as _, jsx as r } from "react/jsx-runtime";
import { useRef as S, useContext as M, useState as O, useEffect as j } from "react";
import i from "classnames";
import v from "../Button/index.js";
import { ThemeContext as F } from "../ThemeContext/index.js";
import Y from "../../icons/ArrowLeft.js";
import D from "../../icons/ArrowLeftBold.js";
import U from "../../icons/ArrowRight.js";
import $ from "../../icons/ArrowRightBold.js";
const q = "forma-ui__tabs__root", z = "forma-ui__tabs__header", G = "forma-ui__tabs__nav", J = "forma-ui__tabs__navButton", K = "forma-ui__tabs__hidden", Q = "forma-ui__tabs__list", V = "forma-ui__tabs__item", X = "forma-ui__tabs__button", Z = "forma-ui__tabs__active", I = "forma-ui__tabs__bage", tt = "forma-ui__tabs__content", ot = "forma-ui__tabs__buttons", et = "forma-ui__tabs__title", rt = "forma-ui__tabs__bagePhone", nt = "forma-ui__tabs__left", lt = "forma-ui__tabs__right", e = {
  root: q,
  header: z,
  nav: G,
  navButton: J,
  hidden: K,
  list: Q,
  item: V,
  button: X,
  active: Z,
  bage: I,
  content: tt,
  buttons: ot,
  title: et,
  bagePhone: rt,
  left: nt,
  right: lt
}, at = 50, T = 34, W = ({ items: t, onClick: s, currentIndex: l }) => {
  var d, g, u, b, m, p, f, n;
  const h = t[l];
  return /* @__PURE__ */ _("div", { className: e.buttons, children: [
    t.length > 1 && /* @__PURE__ */ _("div", { children: [
      ((d = t[l - 1]) == null ? void 0 : d.bage) && /* @__PURE__ */ r(
        "div",
        {
          className: i(e.bagePhone, e.left),
          style: { backgroundColor: (g = t[l - 1].bage) == null ? void 0 : g.backgroundColor, color: (u = t[l - 1].bage) == null ? void 0 : u.color },
          children: (b = t[l - 1].bage) == null ? void 0 : b.content
        }
      ),
      /* @__PURE__ */ r(
        v,
        {
          className: i(e.navButton, !t[l - 1] && e.hidden),
          icon: /* @__PURE__ */ r(Y, {}),
          viewStyle: "tertiary",
          onClick: () => s(t[l - 1].id)
        }
      )
    ] }),
    /* @__PURE__ */ r("div", { className: e.title, children: h == null ? void 0 : h.name }),
    t.length > 1 && /* @__PURE__ */ _("div", { children: [
      ((m = t[l + 1]) == null ? void 0 : m.bage) && /* @__PURE__ */ r(
        "div",
        {
          className: i(e.bagePhone, e.right),
          style: { backgroundColor: (p = t[l + 1].bage) == null ? void 0 : p.backgroundColor, color: (f = t[l + 1].bage) == null ? void 0 : f.color },
          children: (n = t[l + 1].bage) == null ? void 0 : n.content
        }
      ),
      /* @__PURE__ */ r(
        v,
        {
          className: i(e.navButton, !t[l + 1] && e.hidden),
          icon: /* @__PURE__ */ r(U, {}),
          viewStyle: "tertiary",
          onClick: () => s(t[l + 1].id)
        }
      )
    ] })
  ] });
}, P = (t) => !t || t.scrollWidth <= t.clientWidth ? { prev: !1, next: !1 } : t.scrollLeft === 0 ? { prev: !1, next: !0 } : Math.ceil(t.scrollLeft) + t.clientWidth >= t.scrollWidth ? { prev: !0, next: !1 } : { prev: !0, next: !0 }, E = (t) => t == null ? null : t.scrollHeight > t.clientHeight ? t : E(t.parentElement), vt = ({
  items: t,
  current: s,
  onChange: l,
  className: h,
  contentClassName: d,
  tabViewStyle: g = "secondary",
  showSingleTab: u = !0,
  dontRemoveContent: b,
  headerButtons: m,
  disableScroll: p
}) => {
  var y;
  const f = S(null), n = S(null), { viewport: R } = M(F), [C, k] = O({ prev: !1, next: !1 });
  s || (s = (y = t[0]) == null ? void 0 : y.id);
  const B = t.findIndex(({ id: o }) => o === s), w = (o) => {
    k(P(o.target));
  };
  j(() => {
    const o = n.current;
    return o && (o.addEventListener("scroll", w), k(P(o))), () => {
      o && o.addEventListener("scroll", w);
    };
  }, [n, t]);
  const N = (o) => {
    if (l(o), console.log(123), !f.current || p)
      return;
    console.log(234);
    const c = f.current.getBoundingClientRect().top + window.scrollY - at;
    setTimeout(() => {
      const a = E(f.current);
      a && a.scrollTo({
        top: c,
        behavior: "smooth"
      });
    });
  }, H = () => {
    if (!n.current)
      return;
    const o = n.current.offsetWidth, c = n.current.scrollLeft;
    for (let a of n.current.children)
      if (a instanceof HTMLLIElement && a.offsetLeft - c > a.offsetWidth - o) {
        n.current.scrollTo({
          left: a.offsetLeft - T - 1,
          behavior: "smooth"
        });
        break;
      }
  }, x = () => {
    if (!n.current)
      return;
    const o = n.current.offsetWidth, c = n.current.scrollLeft;
    for (let a of n.current.children)
      if (a instanceof HTMLLIElement && a.offsetLeft - c > o - a.offsetWidth) {
        n.current.scrollTo({
          left: a.offsetLeft - T - 1,
          behavior: "smooth"
        });
        break;
      }
  };
  return R === "phone" ? /* @__PURE__ */ _("div", { className: i(e.root, h), ref: f, children: [
    (t.length > 1 || u) && /* @__PURE__ */ r(W, { items: t, onClick: N, currentIndex: B }),
    t.map(({ id: o, children: c }) => o === s || b ? /* @__PURE__ */ r("div", { className: i(e.content, d, o !== s && e.hidden), children: c }, o) : null),
    (t.length > 1 || u) && /* @__PURE__ */ r(W, { items: t, onClick: N, currentIndex: B })
  ] }) : /* @__PURE__ */ _("div", { className: i(e.root, h), ref: f, children: [
    (t.length > 1 || u) && /* @__PURE__ */ _("div", { className: e.header, children: [
      /* @__PURE__ */ _("div", { className: e.nav, children: [
        C.prev && /* @__PURE__ */ r(v, { className: e.navButton, viewStyle: "text", icon: /* @__PURE__ */ r(D, {}), onClick: H }),
        /* @__PURE__ */ r("ul", { className: i(e.list, "tabs-buttons"), ref: n, children: (t.length > 1 || u) && t.map(({ id: o, name: c, testId: a, className: A, bage: L }) => /* @__PURE__ */ r("li", { id: `tab_button_${o}`, className: e.item, "data-testid": a, children: /* @__PURE__ */ r(
          v,
          {
            viewStyle: s === o ? "primary" : g,
            className: i(e.button, s === o && e.active, A),
            iconClassName: e.bage,
            icon: L && /* @__PURE__ */ r("span", { style: { backgroundColor: L.backgroundColor, color: L.color }, children: L.content }),
            onClick: () => N(o),
            reversed: !0,
            children: c
          }
        ) }, o)) }),
        C.next && /* @__PURE__ */ r(v, { className: e.navButton, viewStyle: "text", icon: /* @__PURE__ */ r($, {}), onClick: x })
      ] }),
      m
    ] }),
    t.map(({ id: o, children: c }) => o === s || b ? /* @__PURE__ */ r("div", { className: i(e.content, d, o !== s && e.hidden), children: c }, o) : null)
  ] });
};
export {
  vt as default
};
